import { useEffect, useState } from "react";
import { useAppSelector } from "../Redux/Hooks";

export const useDevmode = () => {
  const {isDevModeJson} =useAppSelector(state=>state.flags)
const {user} =useAppSelector(state=>state.auth)
const [isDevMode, setIsDevMode] = useState(false)
useEffect(() => {
  if(user){
    if(isDevModeJson?.isOn){
      if(isDevModeJson?.allowed.includes(user.phone_number)){
        setIsDevMode(true);
      }else{
        setIsDevMode(false);
      }
    }
  }
}, [user, isDevModeJson])
  return isDevMode;
}